import React, { useState } from 'react';
import { HeatDto, TeamDto, fetchTeamsInHeat } from '../../../api/apis';
import HeatDetailsModal from '../modals/HeatDetailsModal';

interface HeatListProps {
  heats: HeatDto[];
  type: 'started' | 'not-started';
  onHeatStarted: () => void;
}

const HeatList: React.FC<HeatListProps> = ({ heats, type, onHeatStarted }) => {
  const [selectedHeat, setSelectedHeat] = useState<HeatDto | null>(null);
  const [teamsInHeat, setTeamsInHeat] = useState<TeamDto[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleHeatClick = async (heat: HeatDto) => {
    try {
      setIsLoading(true);
      const teams = await fetchTeamsInHeat(heat.id);
      setTeamsInHeat(teams);
      setSelectedHeat(heat);
      setIsModalOpen(true);
    } catch (error) {
      console.error('Failed to fetch teams in heat:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (heats.length === 0) {
    return (
      <div className="text-gray-500 text-center py-4">
        No {type === 'started' ? 'started' : 'not started'} heats
      </div>
    );
  }

  return (
    <>
      <div className="max-h-[250px] overflow-y-auto">
        <div className="space-y-2">
          {heats.map((heat) => (
            <div
              key={heat.id}
              onClick={() => handleHeatClick(heat)}
              className="p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <h3 className="font-medium">{heat.name}</h3>
            </div>
          ))}
        </div>
      </div>

      {selectedHeat && (
        <HeatDetailsModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedHeat(null);
          }}
          heat={selectedHeat}
          teams={teamsInHeat}
          isLoading={isLoading}
          canStart={type === 'not-started'}
          onHeatStarted={onHeatStarted}
        />
      )}
    </>
  );
};

export default HeatList; 